import React from 'react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';

const MeetTheMascot = () => {
  return (
    <main id="main-content" className="bg-white">
      <Navbar />
      
      {/* Header Section */}
      <section className="pt-32 pb-24 bg-[#630503] relative overflow-hidden">
        <div aria-hidden="true" className="pointer-events-none absolute inset-x-0 bottom-0 h-1/5 bg-gradient-to-b from-[#630503] to-white"></div>

        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
          <div className="text-center">
            <div className="mb-16">
              <span className="inline-block bg-white/10 backdrop-blur-sm text-white px-6 py-3 text-sm font-medium uppercase tracking-[0.2em] mb-8 rounded-full">
                Our Team
              </span>
              <h1 className="text-3xl sm:text-4xl lg:text-5xl xl:text-6xl font-light text-white mb-8 leading-[1.1] max-w-4xl mx-auto">
                Meet the <span className="font-bold">Mascot</span>
              </h1>
              <div className="w-24 h-px bg-white/40 mx-auto mb-8"></div>
              <p className="text-lg lg:text-xl leading-relaxed text-white/95 max-w-3xl mx-auto">
                Get to know Highbridge the Hawk, our beloved school mascot who represents the spirit and pride of P.S. 11X.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Main Content Section */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            
            {/* Mascot Image */}
            <div className="order-2 lg:order-1">
              <div className="bg-[#630503]/5 rounded-xl p-8 shadow-xl border border-[#630503]/20">
                <img 
                  src="/assets/images/meetthemascot/Mascot.jpg" 
                  alt="Highbridge the Hawk with students"
                  className="w-full h-auto rounded-lg shadow-lg"
                />
              </div>
            </div>

            {/* Welcome Message */}
            <div className="order-1 lg:order-2">
              <div className="bg-white rounded-xl p-8 lg:p-12 shadow-xl border border-gray-100 relative overflow-hidden">
                <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-[#630503] via-[#8B4513] to-[#A0522D]"></div>
                
                <h2 className="text-2xl sm:text-3xl lg:text-4xl font-bold text-gray-900 mb-8 text-center">
                  <span className="text-[#630503]">WELCOME!</span>
                </h2>
                
                <div className="prose prose-lg max-w-none">
                  <p className="text-lg text-gray-700 leading-relaxed mb-6">
                    Hello P.S. 11 Family! I am Highbridge the Hawk and I am the school mascot! My ancestors 
                    have been part of Highbridge since the Indigenous days of long ago! With the help of 
                    PBIS- we can work together and SOAR!
                  </p>
                  
                  <div className="bg-[#630503]/5 rounded-lg p-6 mb-6">
                    <p className="text-lg text-[#630503] font-semibold italic text-center">
                      "Fly high! There is a lot of sky out there for brave birds!"
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* About Me Section */}
      <section className="py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-3xl lg:text-4xl font-light text-gray-900 mb-8">
              About <span className="font-bold text-[#630503]">Me</span>
            </h2>
            <div className="w-24 h-px bg-[#630503]/40 mx-auto mb-8"></div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            <div className="bg-white rounded-xl p-8 shadow-xl border border-gray-100 relative overflow-hidden">
              <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-[#630503] to-[#8B4513]"></div>
              <h3 className="text-xl font-bold text-gray-900 mb-4">Flying Adventures</h3>
              <p className="text-gray-700 leading-relaxed">
                I love to fly from the satellite to the main building, connecting our two campuses and 
                bringing joy to all our students along the way.
              </p>
            </div>

            <div className="bg-white rounded-xl p-8 shadow-xl border border-gray-100 relative overflow-hidden">
              <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-[#8B4513] to-[#A0522D]"></div>
              <h3 className="text-xl font-bold text-gray-900 mb-4">My Heritage</h3>
              <p className="text-gray-700 leading-relaxed">
                I am named after the High Bridge - the first bridge of New York City! My connection to 
                this historic landmark runs deep through our community's history.
              </p>
            </div>

            <div className="bg-white rounded-xl p-8 shadow-xl border border-gray-100 relative overflow-hidden">
              <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-[#A0522D] to-[#630503]"></div>
              <h3 className="text-xl font-bold text-gray-900 mb-4">Bronx Pride</h3>
              <p className="text-gray-700 leading-relaxed">
                I believe in Bronx Brilliance! Our community has always been brilliant and will always 
                be brilliant - from hip-hop to academic excellence.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Contact Section */}
      <section className="py-20 bg-white">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="bg-[#630503]/5 rounded-xl p-8 lg:p-12 shadow-xl border border-[#630503]/20">
            <div className="text-center mb-8">
              <h2 className="text-3xl lg:text-4xl font-bold text-gray-900 mb-4">
                Contact <span className="text-[#630503]">Info</span>
              </h2>
              <div className="w-16 h-px bg-[#630503]/40 mx-auto"></div>
            </div>
            
            <div className="grid grid-cols-1 md:grid-cols-2 gap-8 text-center">
              <div>
                <h3 className="text-lg font-bold text-gray-900 mb-4">Main Building</h3>
                <p className="text-gray-700">1257 Ogden Avenue, Bronx, NY 10452</p>
              </div>
              
              <div>
                <h3 className="text-lg font-bold text-gray-900 mb-4">Satellite Building</h3>
                <p className="text-gray-700">1399 Ogden Ave, Bronx, NY 10452</p>
              </div>
              
              <div className="md:col-span-2">
                <h3 className="text-lg font-bold text-gray-900 mb-4">Email</h3>
                <p className="text-gray-700">TheHawk@ps11.com</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </main>
  );
};

export default MeetTheMascot;
